// extracted by mini-css-extract-plugin
module.exports = {"modal":"exempt-modal_modal__3PS9l","modalHeader":"exempt-modal_modalHeader__2pfF6","modalBody":"exempt-modal_modalBody__2llwn","modalFooter":"exempt-modal_modalFooter__38fx8"};